import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

const getPcTypeLabel = (type: any): string => {
  if (!type) return '';
  if (typeof type === 'string') return type;
  if (Array.isArray(type)) {
    const titles = type.map((t) => (t && typeof t.title === 'string' ? t.title : '')).filter(Boolean);
    return titles.join(' / ');
  }
  if (typeof type === 'object' && typeof type.title === 'string') return type.title;
  return String(type);
};

export default function PerformanceCrieteria({ openDialog, setOpenDialog, selectedTemplate }: any) {
  return (
    <Dialog open={openDialog} fullWidth maxWidth="md" onClose={() => setOpenDialog(false)}>
      <DialogTitle>Performance Criteria</DialogTitle>

      <DialogContent dividers>
        {selectedTemplate?.pcs?.length ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>PC Code</TableCell>
                <TableCell>PC Name</TableCell>
                <TableCell>Total Marks</TableCell>
                <TableCell>Critical</TableCell>
                <TableCell>Type</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {selectedTemplate.pcs.map((pc: any) => (
                <TableRow key={pc._id}>
                  <TableCell>{pc.pcCode}</TableCell>
                  <TableCell>{pc.pcName}</TableCell>
                  <TableCell>{pc.totalMarks}</TableCell>
                  <TableCell>{pc.isCritical ? 'Yes' : 'No'}</TableCell>
                  <TableCell>{getPcTypeLabel(pc.type)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No Performance Criteria found.</Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpenDialog(false)}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
